import { render, staticRenderFns } from "./SaunaShiftsView.vue?vue&type=template&id=81ade26e&"
import script from "./SaunaShiftsView.vue?vue&type=script&lang=ts&"
export * from "./SaunaShiftsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports